import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumUserTenantRole implements BaseEnumType {
  private static allValues: EnumUserTenantRole[] = []; // make sure this is top-most
  
  public static outletsAndGroupsView = new EnumUserTenantRole(0, "OutletsAndGroupsView", "enum_user_tenant_role_outlets_and_groups_view");
  public static outletsAndGroupsEdit = new EnumUserTenantRole(1, "OutletsAndGroupsEdit", "enum_user_tenant_role_outlets_and_groups_edit");
  public static outletsAndGroupsAdmin = new EnumUserTenantRole(2, "OutletsAndGroupsAdmin", "enum_user_tenant_role_outlets_and_groups_admin");
  public static tenantsView = new EnumUserTenantRole(3, "TenantsView", "enum_user_tenant_role_tenants_view");
  public static tenantsEdit = new EnumUserTenantRole(4, "TenantsEdit", "enum_user_tenant_role_tenants_edit");
  public static productsView = new EnumUserTenantRole(5, "ProductsView", "enum_user_tenant_role_products_view");
  public static productsEdit = new EnumUserTenantRole(6, "ProductsEdit", "enum_user_tenant_role_products_edit");
  public static productsAdmin = new EnumUserTenantRole(7, "ProductsAdmin", "enum_user_tenant_role_products_admin");
  public static pricesView = new EnumUserTenantRole(8, "PricesView", "enum_user_tenant_role_prices_view");
  public static pricesEdit = new EnumUserTenantRole(9, "PricesEdit", "enum_user_tenant_role_prices_edit");
  public static pricesAdmin = new EnumUserTenantRole(10, "PricesAdmin", "enum_user_tenant_role_prices_admin");
  public static stockView = new EnumUserTenantRole(11, "StockView", "enum_user_tenant_role_stock_view");
  public static stockEdit = new EnumUserTenantRole(12, "StockEdit", "enum_user_tenant_role_stock_edit");
  public static stockAdmin = new EnumUserTenantRole(13, "StockAdmin", "enum_user_tenant_role_stock_admin");
  public static allUsers = new EnumUserTenantRole(14, "AllUsers", "enum_user_tenant_role_all_users");
  public static containersView = new EnumUserTenantRole(15, "ContainersView", "enum_user_tenant_role_containers_view");
  public static containersAdmin = new EnumUserTenantRole(16, "ContainersAdmin", "enum_user_tenant_role_containers_admin");
  public static ordersView = new EnumUserTenantRole(17, "OrdersView", "enum_user_tenant_role_orders_view");
  public static ordersAdmin = new EnumUserTenantRole(18, "OrdersAdmin", "enum_user_tenant_role_orders_admin");
  public static distributionView = new EnumUserTenantRole(19, "DistributionView", "enum_user_tenant_role_distribution_view");
  public static distributionAdmin = new EnumUserTenantRole(20, "DistributionAdmin", "enum_user_tenant_role_distribution_admin");
  public static premierSystemsAdmin = new EnumUserTenantRole(21, "PremierSystemsAdmin", "enum_user_tenant_role_premier_systems_admin");
  public static companyAdmin = new EnumUserTenantRole(22, "CompanyAdmin", "enum_user_tenant_role_company_admin");
  public static usersView = new EnumUserTenantRole(23, "UsersView", "enum_user_tenant_role_users_view");
  public static usersAdmin = new EnumUserTenantRole(24, "UsersAdmin", "enum_user_tenant_role_users_admin");
  public static dutyView = new EnumUserTenantRole(25, "DutyView", "enum_user_tenant_role_duty_view");
  public static dutyAdmin = new EnumUserTenantRole(26, "DutyAdmin", "enum_user_tenant_role_duty_admin");
  public static accountPostingView = new EnumUserTenantRole(27, "AccountPostingView", "enum_user_tenant_role_account_posting_view");
  public static accountPostingAdmin = new EnumUserTenantRole(28, "AccountPostingAdmin", "enum_user_tenant_role_account_posting_admin");
  public static reportsView = new EnumUserTenantRole(29, "ReportsView", "enum_user_tenant_role_reports_view");
  public static systemInternal = new EnumUserTenantRole(30, "SystemInternal", "enum_user_tenant_role_system_internal");
  public static billingAdmin = new EnumUserTenantRole(31, "BillingAdmin", "enum_user_tenant_role_billing_admin");
  public static ullagesView = new EnumUserTenantRole(32, "UllagesView", "enum_user_tenant_role_ullages_view");
  public static ullagesAdmin = new EnumUserTenantRole(33, "UllagesAdmin", "enum_user_tenant_role_ullages_admin");
  public static purchaseOrdersView = new EnumUserTenantRole(34, "PurchaseOrdersView", "enum_user_tenant_role_purchase_orders_view");
  public static purchaseOrdersAdmin = new EnumUserTenantRole(35, "PurchaseOrdersAdmin", "enum_user_tenant_role_purchase_orders_admin");
  public static tenantDocumentView = new EnumUserTenantRole(36, "TenantDocumentView", "enum_user_tenant_role_tenant_document_view");
  public static tenantDocumentAdmin = new EnumUserTenantRole(37, "TenantDocumentAdmin", "enum_user_tenant_role_tenant_document_admin");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUserTenantRole.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOutletsAndGroupsView() { return this === EnumUserTenantRole.outletsAndGroupsView; }
  public isOutletsAndGroupsEdit() { return this === EnumUserTenantRole.outletsAndGroupsEdit; }
  public isOutletsAndGroupsAdmin() { return this === EnumUserTenantRole.outletsAndGroupsAdmin; }
  public isTenantsView() { return this === EnumUserTenantRole.tenantsView; }
  public isTenantsEdit() { return this === EnumUserTenantRole.tenantsEdit; }
  public isProductsView() { return this === EnumUserTenantRole.productsView; }
  public isProductsEdit() { return this === EnumUserTenantRole.productsEdit; }
  public isProductsAdmin() { return this === EnumUserTenantRole.productsAdmin; }
  public isPricesView() { return this === EnumUserTenantRole.pricesView; }
  public isPricesEdit() { return this === EnumUserTenantRole.pricesEdit; }
  public isPricesAdmin() { return this === EnumUserTenantRole.pricesAdmin; }
  public isStockView() { return this === EnumUserTenantRole.stockView; }
  public isStockEdit() { return this === EnumUserTenantRole.stockEdit; }
  public isStockAdmin() { return this === EnumUserTenantRole.stockAdmin; }
  public isAllUsers() { return this === EnumUserTenantRole.allUsers; }
  public isContainersView() { return this === EnumUserTenantRole.containersView; }
  public isContainersAdmin() { return this === EnumUserTenantRole.containersAdmin; }
  public isOrdersView() { return this === EnumUserTenantRole.ordersView; }
  public isOrdersAdmin() { return this === EnumUserTenantRole.ordersAdmin; }
  public isDistributionView() { return this === EnumUserTenantRole.distributionView; }
  public isDistributionAdmin() { return this === EnumUserTenantRole.distributionAdmin; }
  public isPremierSystemsAdmin() { return this === EnumUserTenantRole.premierSystemsAdmin; }
  public isCompanyAdmin() { return this === EnumUserTenantRole.companyAdmin; }
  public isUsersView() { return this === EnumUserTenantRole.usersView; }
  public isUsersAdmin() { return this === EnumUserTenantRole.usersAdmin; }
  public isDutyView() { return this === EnumUserTenantRole.dutyView; }
  public isDutyAdmin() { return this === EnumUserTenantRole.dutyAdmin; }
  public isAccountPostingView() { return this === EnumUserTenantRole.accountPostingView; }
  public isAccountPostingAdmin() { return this === EnumUserTenantRole.accountPostingAdmin; }
  public isReportsView() { return this === EnumUserTenantRole.reportsView; }
  public isSystemInternal() { return this === EnumUserTenantRole.systemInternal; }
  public isBillingAdmin() { return this === EnumUserTenantRole.billingAdmin; }
  public isUllagesView() { return this === EnumUserTenantRole.ullagesView; }
  public isUllagesAdmin() { return this === EnumUserTenantRole.ullagesAdmin; }
  public isPurchaseOrdersView() { return this === EnumUserTenantRole.purchaseOrdersView; }
  public isPurchaseOrdersAdmin() { return this === EnumUserTenantRole.purchaseOrdersAdmin; }
  public isTenantDocumentView() { return this === EnumUserTenantRole.tenantDocumentView; }
  public isTenantDocumentAdmin() { return this === EnumUserTenantRole.tenantDocumentAdmin; }

  public static getValues(): readonly EnumUserTenantRole[] {
    return EnumUserTenantRole.allValues;
  }

  public static getValuesExcept0(): readonly EnumUserTenantRole[] {
    return EnumUserTenantRole.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUserTenantRole {
    const found = EnumUserTenantRole.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUserTenantRole - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUserTenantRole): EnumUserTenantRole {
    const found = name ? EnumUserTenantRole.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUserTenantRole - Value not found: ${ name }`);
    }

    return found;
  }
}